/**
 * The full-page loader (BrandLoading) covers the page until the user's data arrives. On the first
 * load of a server-rendered page the page under it is already there, and for a signed-out visitor in
 * the default theme it is the page they will get, so covering it only delayed the first paint of any
 * content until the whole app had run: on stock pages that was the LCP, and everywhere it put a
 * full-screen spinner between the server's page and the same page again (Speed Index).
 *
 * So there the loader is wrapped in `LOADER_HELD_CLASS`, which is visible only once the script below
 * has marked the document: a stored Cognito session (the page will turn into theirs), a saved light
 * theme (the server renders dark), or the app shell. It runs in the document head, before first
 * paint; any error holds the loader. The session test is _app's `hasStoredCognitoSession`.
 */
export const LOADER_HELD_CLASS = "ortex-loader-held-only";

const HOLD_CLASS = "ortex-hold-loader";

export const LOADER_HOLD_SCRIPT = `(function(){var d=document.documentElement;try{var s=window.localStorage,k=Object.keys(s);if(s.getItem("theme")==="light")d.setAttribute("data-theme","light");if(window.Capacitor||s.getItem("theme")==="light"||k.some(function(x){return x.indexOf("CognitoIdentityServiceProvider")===0&&x.slice(-12)===".accessToken"}))d.className+=" ${HOLD_CLASS}"}catch(e){d.className+=" ${HOLD_CLASS}"}})();`;

export const LOADER_HOLD_STYLE = `html:not(.${HOLD_CLASS}) .${LOADER_HELD_CLASS}{display:none}`;
